import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export default function ModalCancel({
  isCanceling,
  onCancelClose,
  onCancelContinue,
}) {
  const { t } = useTranslation()

  return (
    <Modal show={isCanceling} onHide={onCancelClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('event.cancel_task_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t('event.cancel_task_message')}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancelClose}>
          {t('buttons.cancel')}
        </Button>
        <Button variant="danger" onClick={onCancelContinue}>
          {t('buttons.continue')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
